import React from 'react'
import "./How_to_join.css";
import Common_heading from '../../Common_Component/Common_heading/Common_heading';

export default function How_to_join() {
    return (

        <section className='howjoin-section'>
            <div className='container'>
                <Common_heading headingText={"How to Join?"} />

                <div className='row join'>
                    <div className='col-lg-6 col-12 col-md-6 col-sm-6 content'>
                        <h1 className='main-head'>Join us with</h1>
                        <div className='inner'>
                            <div className=' left-div'>
                                <p className='head-number'>5</p>
                            </div>
                            <div className='right-div'>
                                <p className='head'>Easy Steps</p>
                                <p className='para'>Joining Our services is a simple
                                    process that allows you to become
                                    part of a dynamic network & start
                                    earning through our platform.</p>
                            </div>
                        </div>
                    </div>
                    <div className='col-lg-6 col-12 col-md-6 col-sm-6 step-video'>
                        <video autoPlay loop muted playsinline>
                            <source src={process.env.PUBLIC_URL + "/Assets/Images/home/how_to_join/video/ABSAR_MONEY.mp4"} type="video/mp4" />
                        </video>
                    </div>
                </div>
            </div>

        </section >
    )
}
